import { Component } from 'react';
import { connect } from 'react-redux';
import elementType from 'prop-types-extra/lib/elementType';
import PropTypes from 'prop-types';
import { GONE } from 'http-status';

import Layout from 'components/page/Layout';
import * as actions from './actions';
import mapStateToProps from './mapStateToProps';
import { reducer } from './duck';

class CmsTemplate extends Component {
  static propTypes = {
    CmsTemplateComponent: elementType,
    layoutError: PropTypes.object,
    match: PropTypes.object,
    initCmsModule: PropTypes.func,
  };

  componentDidMount() {
    const { match, initCmsModule } = this.props;

    initCmsModule({ match, withFetchAction: false });
  }

  isMakeModelDisabled() {
    const { layoutError } = this.props;

    return layoutError && layoutError.code === GONE;
  }

  render() {
    const { CmsTemplateComponent, layoutError, ...rest } = this.props;

    if (this.isMakeModelDisabled()) {
      return <CmsTemplateComponent />;
    }

    if (CmsTemplateComponent) {
      return <CmsTemplateComponent {...rest} />;
    }

    if (layoutError) {
      return <Layout error={layoutError} />;
    }

    return null;
  }
}

export default connect(mapStateToProps, actions)(CmsTemplate);

export { reducer, actions };
